export const PROMOTION_LIST = {
  RefuelingPromotion: {
    name: '加油站',
    analyticsName: '加油站優惠',
    key: 'RefuelingPromotion',
    id: 'refueling-promotion',
    order: 1,
  },
  ParkingPromotion: {
    name: '停車場',
    analyticsName: '停車場優惠',
    key: 'ParkingPromotion',
    id: 'parking-promotion',
    order: 2,
  },
  OnStreetParkingPromotion: {
    name: '路邊停車',
    analyticsName: '路停優惠優惠',
    key: 'OnStreetParkingPromotion',
    id: 'on-street-parking-promotion',
    order: 3,
  },
  'InvoicePromotion::VehicleMaintenancePromotion': {
    name: '汽車美容',
    analyticsName: '汽車美容優惠',
    key: 'InvoicePromotion::VehicleMaintenancePromotion',
    id: 'invoice-promotion-vehicle-maintenance-promotion',
    order: 4,
  },
  'InvoicePromotion::InsurancePromotion': {
    name: '保險',
    analyticsName: '保險優惠',
    key: 'InvoicePromotion::InsurancePromotion',
    id: 'invoice-promotion-insurance-promotion',
    order: 5,
  },
  'InvoicePromotion::WashCarPromotion': {
    name: '洗車',
    analyticsName: '洗車優惠',
    key: 'InvoicePromotion::WashCarPromotion',
    id: 'invoice-promotion-wash-car-promotion',
    order: 6,
  },
  'InvoicePromotion::ChargingPromotion': {
    name: '充電站',
    analyticsName: '充電優惠',
    key: 'InvoicePromotion::ChargingPromotion',
    id: 'invoice-promotion-charging-promotion',
    order: 7,
  },
  'InvoicePromotion::RentalCarPromotion': {
    name: '租車',
    analyticsName: '租車優惠',
    key: 'InvoicePromotion::RentalCarPromotion',
    id: 'invoice-promotion-rental-car-promotion',
    order: 8,
  },
  'InvoicePromotion::VehicleRepairPromotion': {
    name: '保修廠',
    analyticsName: '維修保養優惠',
    key: 'InvoicePromotion::VehicleRepairPromotion',
    id: 'invoice-promotion-vehicle-repair-promotion',
    order: 9,
  },
};
